export default __webpack_public_path__ + "static/media/7.aa7737e1.svg";